import isAbandonedCartRoute from './generatePath';

export default isAbandonedCartRoute;
